import PropTypes from 'prop-types';
import React from 'react';

import { Link } from 'fr-shared/components';

const CommercialInvoiceInformation = ({ commercialInvoice }) => (
  <div className="container">
    <div className="alert alert-success">
      Commercial Invoice created successfully.
      <div>
        <Link to={{ pathname: commercialInvoice.path }} openNewWindow>
          Click here to download the <strong>commercial invoice</strong>
        </Link>
      </div>
    </div>
  </div>
);

CommercialInvoiceInformation.propTypes = {
  commercialInvoice: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

export default CommercialInvoiceInformation;
